var _rect, _rect2, _rect3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#13C2C2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.56445,
    width: 6,
    height: 6.29003,
    rx: 1,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19.1445,
    width: 6,
    height: 6.29003,
    rx: 1,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.9512C24 15.5034 24.4477 15.9512 25 15.9512C25.5523 15.9512 26 15.5034 26 14.9512H24ZM17 9.70947V8.70947C16.5998 8.70947 16.2382 8.94803 16.0807 9.31591C15.9232 9.68379 16.0002 10.1101 16.2764 10.3997L17 9.70947ZM19.2764 13.5447C19.6576 13.9443 20.2906 13.9593 20.6902 13.5781C21.0899 13.1969 21.1048 12.5639 20.7236 12.1643L19.2764 13.5447ZM20.7236 7.25468C21.1048 6.85505 21.0899 6.22206 20.6902 5.84086C20.2906 5.45966 19.6576 5.4746 19.2764 5.87423L20.7236 7.25468ZM16.2764 9.01924C15.8952 9.41887 15.9101 10.0519 16.3098 10.4331C16.7094 10.8143 17.3424 10.7993 17.7236 10.3997L16.2764 9.01924ZM26 14.9512V11.8061H24V14.9512H26ZM26 11.8061C26 10.1409 24.7008 8.70947 23 8.70947V10.7095C23.5083 10.7095 24 11.1555 24 11.8061H26ZM23 8.70947H17V10.7095H23V8.70947ZM16.2764 10.3997L19.2764 13.5447L20.7236 12.1643L17.7236 9.01924L16.2764 10.3997ZM19.2764 5.87423L16.2764 9.01924L17.7236 10.3997L20.7236 7.25468L19.2764 5.87423Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.0488C8 16.4965 7.55228 16.0488 7 16.0488C6.44772 16.0488 6 16.4965 6 17.0488H8ZM15 22.2905V23.2905C15.4002 23.2905 15.7618 23.0519 15.9193 22.6841C16.0768 22.3162 15.9998 21.8898 15.7236 21.6003L15 22.2905ZM12.7236 18.4553C12.3424 18.0556 11.7094 18.0407 11.3098 18.4219C10.9101 18.8031 10.8952 19.4361 11.2764 19.8357L12.7236 18.4553ZM11.2764 24.7453C10.8952 25.1449 10.9101 25.7779 11.3098 26.1591C11.7094 26.5403 12.3424 26.5254 12.7236 26.1258L11.2764 24.7453ZM15.7236 22.9807C16.1048 22.5811 16.0899 21.9481 15.6902 21.5669C15.2906 21.1857 14.6576 21.2007 14.2764 21.6003L15.7236 22.9807ZM6 17.0488V20.1938H8V17.0488H6ZM6 20.1938C6 21.8591 7.29919 23.2905 9 23.2905V21.2905C8.49168 21.2905 8 20.8445 8 20.1938H6ZM9 23.2905H15V21.2905H9V23.2905ZM15.7236 21.6003L12.7236 18.4553L11.2764 19.8357L14.2764 22.9807L15.7236 21.6003ZM12.7236 26.1258L15.7236 22.9807L14.2764 21.6003L11.2764 24.7453L12.7236 26.1258Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/Move.e95ea2a55515fc18195e64aac99a1ffa.svg";
export { ForwardRef as ReactComponent };